import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth, ensureUserProfile } from "./firebase";
import MainPage from "./pages/MainPage";
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";
import "./App.css";

function App() {
  const [authState, setAuthState] = useState({
    user: null,
    role: "user",
    loading: true,
  });

  useEffect(() => {
    if (!auth) {
      setAuthState({ user: null, role: "user", loading: false });
      return undefined;
    }

    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (!firebaseUser) {
        setAuthState({ user: null, role: "user", loading: false });
        return;
      }

      const profile = await ensureUserProfile(firebaseUser);
      setAuthState({
        user: firebaseUser,
        role: profile?.role || "user",
        loading: false,
      });
    });

    return () => unsubscribe();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/login" element={<LoginPage {...authState} />} />
        <Route path="/admin" element={<AdminPage {...authState} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
